export default __webpack_public_path__ + "static/media/SR_Baphomet.5ade2b41.png";